import { z } from 'zod';
import { utmSchema } from '../auth/utm';
import { USERNAME_REGEXP } from './updateUser';
export const createUserV2BodySchema = z.object({
    name: z.string().min(3).regex(USERNAME_REGEXP),
    utm: utmSchema.optional(),
});
export const createUserV2InputSchema = createUserV2BodySchema;
